package one.healthium.insights.data.dto


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class ShoppingListDto(
    @SerialName("id") val id: String,
    @SerialName("name") val name: String? = null,
    @SerialName("items") val items: List<ShoppingItemDto>
)

@Serializable
internal data class ShoppingItemDto(
    @SerialName("id") val id: String,
    @SerialName("name") val name: String,
    @SerialName("category") val category: String? = null,
    @SerialName("emoji") val emoji: String? = null,
    @SerialName("quantity") val quantity: String? = null,
    @SerialName("unit") val unit: ShoppingItemUnitDto? = null,
)

@Serializable
internal data class ShoppingItemUnitDto(
    @SerialName("metric") val metric: UnitDto?,
    @SerialName("imperial") val imperial: UnitDto?,
)

@Serializable
internal data class UnitDto(
    @SerialName("amount") val amount: Double,
    @SerialName("unit") val unit: String,
)
